import React, { useState, useEffect } from "react";
import Userdashboardheader from "../userdashboardheader/Userdashboardheader";
import { FiArrowRight } from "react-icons/fi";
import Checkout from "../Checkout";
import { MdClose } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import Swal from "sweetalert2";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { RxDash } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import { Pagination, Navigation, FreeMode } from "swiper";
import Loader from "../Loader";
import axios from "axios";
import './userdashboardplans.css';
const Userdashboardplans = ({ route }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeMethod, setActiveMethod] = useState();
  const [amount, setAmount] = useState();
  const [loader, setLoader] = useState(false);
  const [userBalance, setUserBalance] = useState(0);
  const [stakingEnabled, setStakingEnabled] = useState(true);

  const navigate = useNavigate();

  const [withdrawMethods] = useState([
    {
      id: 1,
      min: 500,
      max: 5000,
      image: "/btc.png",
      method: "BTC",
      type: "basic plan",
      percent: "5%",
      duration: "5 days",
    },
    {
      id: 2,
      min: 6000,
      max: 10000,
      image: "/bnb.png",
      method: "USDT",
      type: "forex/crypto plan",
      percent: "15%",
      duration: "6 days",
    },
    {
      id: 3,
      min: 11000,
      max: 20000,
      image: "/tron.png",
      method: "tether(TRC20)",
      type: "agro-tech plan",
      percent: "20%",
      duration: "7 days",
    },
    {
      id: 4,
      min: 21000,
      max: 90000,
      image: "/tron.png",
      method: "tether(TRC20)",
      type: "gold-stock plan",
      percent: "25%",
      duration: "8 days",
    },
    {
      id: 5,
      min: 100000,
      max: 5000000,
      image: "/tron.png",
      method: "tether(TRC20)",
      type: "oil and gas plan",
      percent: "30%",
      duration: "9 days",
    },
    {
      id: 6,
      min: 6000000,
      max: 10000000,
      image: "/tron.png",
      method: "tether(TRC20)",
      type: "real estate plan",
      percent: "35%",
      duration: "10 days",
    },
  ]);

  const [plans] = useState([
    {
      id: 1,
      min: 500,
      max: 5000,
      type: "Basic Staking",
      apy: "5.5%",
      duration: "30 days",
      description: "Start your crypto staking journey",
      supportedAssets: ["BTC", "ETH", "USDT"]
    },
    {
      id: 2,
      min: 6000,
      max: 10000,
      type: "Silver Staking",
      apy: "7.5%",
      duration: "60 days",
      description: "Enhanced rewards for longer commitment",
      supportedAssets: ["BTC", "ETH", "USDT", "XRP"]
    },
    {
      id: 3,
      min: 11000,
      max: 20000,
      type: "Gold Staking",
      apy: "10%",
      duration: "90 days",
      description: "Premium staking rewards",
      supportedAssets: ["BTC", "ETH", "USDT", "XRP", "BNB"]
    },
    {
      id: 4,
      min: 21000,
      max: 90000,
      type: "Platinum Staking",
      apy: "12.5%",
      duration: "180 days",
      description: "Maximum rewards for serious stakers",
      supportedAssets: ["BTC", "ETH", "USDT", "XRP", "BNB"]
    }
  ]);

  const [selectedCrypto, setSelectedCrypto] = useState(null);

  // sweet alert function

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  // Add function to fetch user's ledger balance
  useEffect(() => {
    const fetchLedgerBalance = async () => {
      try {
        const response = await axios.get(`${route}/auth/getData`, {
          headers: {
            'x-access-token': localStorage.getItem('token')
          }
        });
        setUserBalance(response.data.balance || 0);
      } catch (error) {
        console.error('Error fetching ledger balance:', error);
      }
    };

    fetchLedgerBalance();
  }, [route]);

  useEffect(() => {

    const fetchStakingStatus = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${route}/auth/settings`, {
          headers: {
            'x-access-token': token
          }
        });
        setStakingEnabled(response.data.settings.stakingEnabled);
      } catch (error) {
        console.error('Error fetching staking status:', error);
      }
    };
    fetchStakingStatus();
  }, []);


  // Update stake function (previously invest)
  const createStake = async () => {
    try {
      setLoader(true);

      if (!selectedCrypto) {
        Toast.fire({
          icon: 'error',
          title: 'Please select a crypto asset to stake'
        });
        return;
      }

      // Check if user has sufficient balance in ledger
      if (userBalance < amount) {
        Toast.fire({
          icon: 'error',
          title: 'Insufficient ledger balance. Please fund your ledger first.'
        });
        return;
      }

      const response = await axios.post(
        `${route}/staking/create`,
        {
          amount: amount,
          cryptoAsset: selectedCrypto,
          apy: activeMethod.apy.replace('%', ''),
          min: parseInt(activeMethod.min),
          max: parseInt(activeMethod.max),
          plan: activeMethod.type,
          duration: activeMethod.duration.split(' ')[0]
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('token')
          }
        }
      );

      const result = response.data;
      
      if (result.status === 'ok') {
        Toast.fire({
          icon: 'success',
          title: `Successfully staked $${result.stake.amount} in ${result.stake.cryptoAsset}`
        });
        navigate('/investments');
      } else {
        Toast.fire({
          icon: 'error',
          title: result.message
        });
      }
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Failed to create stake'
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div>
        {loader && <Loader />}
        {showModal && stakingEnabled && (
          <AnimatePresence
            initial={{ y: 45, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.65, delay: 0.4 }}
          >
            <motion.div>
              <div className="modal-container">
                <div className="modal">
                  <div className="modal-header">
                    <h2>Selected Plan: {activeMethod.type}</h2>
                    <p>
                      Min: {activeMethod.min} - Max: {activeMethod.max}
                    </p>
                    <p className="balance-info">Your Ledger Balance: ${userBalance.toFixed(2)} USD</p>
                  </div>
                  <MdClose
                    className="close-modal-btn"
                    onClick={() => setShowModal(false)}
                  />
                  <div className="modal-input-container">
                    <div className="crypto-select">
                      <label>Select Crypto Asset to Stake</label>
                      <div className="select-wrapper">
                        <select 
                          value={selectedCrypto} 
                          onChange={(e) => setSelectedCrypto(e.target.value)}
                          required
                        >
                          <option value="">Select Asset</option>
                          {activeMethod.supportedAssets.map(asset => (
                            <option key={asset} value={asset}>
                              {asset}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="modal-input">
                      <input
                        type="tel"
                        placeholder="0.00"
                        onChange={(e) => setAmount(parseInt(e.target.value))}
                      />
                      <span>USD</span>
                    </div>
                  </div>
                  <div className="modal-btn-container">
                    <button
                      className="noselect"
                      onClick={() => setShowModal(false)}
                    >
                      <span className="text">Close</span>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"></path>
                        </svg>
                      </span>
                    </button>
                    <button
                      className="next"
                      onClick={() => {
                        if (amount < activeMethod.min) {
                          Toast.fire({
                            icon: "error",
                            title: `Amount is lower than minimum stake amount`
                          });
                        } else if (amount > activeMethod.max) {
                          Toast.fire({
                            icon: "error",
                            title: `Amount is higher than maximum stake amount`
                          });
                        } else if (amount === undefined || isNaN(amount)) {
                          Toast.fire({
                            icon: "error",
                            title: `Please enter a valid amount`
                          });
                        } else if (amount > userBalance) {
                          Toast.fire({
                            icon: "error",
                            title: `Insufficient ledger balance. Please fund your ledger first.`
                          });
                        } else {
                          createStake();
                        }
                      }}
                    >
                      <span className="label">Create Stake</span>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path
                            fill="currentColor"
                            d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                          ></path>
                        </svg>
                      </span>
                    </button>
                  </div>
                  {userBalance < activeMethod.min && (
                    <div className="insufficient-balance-warning">
                      <p>Your ledger balance is insufficient for this plan.</p>
                      <button onClick={() => navigate('/fundwallet')} className="fund-ledger-btn">
                        Fund Ledger
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        )}
        <Userdashboardheader route={route} />

        {stakingEnabled ? (
        <div className="page-swiper-wrapper">
          <div className="page-header">
            <h3>Choose a Staking Plan</h3>
            <h2>Staking Plans</h2>
            <p>Choose a staking plan to start earning immediately</p>
            <div className="ledger-balance-display">
              <h4>Your Ledger Balance: ${userBalance.toFixed(2)} USD</h4>
              <button onClick={() => navigate('/fundwallet')} className="fund-ledger-btn">
                Fund Ledger
              </button>
            </div>
          </div>
          <div className="swiper-container">
            <Swiper
              slidesPerView={3}
              spaceBetween={20}
              slidesPerGroup={1}
              loop={true}
              loopFillGroupWithBlank={true}
              navigation={true}
              modules={[Navigation]}
              className="mySwiper"
            >
              {plans.map((plan) => (
                <SwiperSlide key={plan.id} className="my-slide">
                  <div className="crypto-card-img-container dashboard-plan-card-header">
                    <h3>{plan.type}</h3>
                    <div className="plan-card-headerdiv">
                      {plan.type === "Unlimited" ? (
                        <h3>Unlimited</h3>
                      ) : (
                        <h3>$ {plan.max} USD</h3>
                      )}
                    </div>
                  </div>
                  <div className="investrange-container investcard-cont">
                    <div className="investrange-card invest-card">
                      <p>Minimum Possible Stake:</p>
                      <RxDash />
                        <p>$ {plan.min} USD</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>Maximum Possible Stake:</p>
                      <RxDash />
                      <p>$ {plan.max} USD</p>
                    </div>

                    <div className="investrange-card invest-card">
                      <p>Percentage:</p>
                      <RxDash />
                      <p>{plan.apy}</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>Maximum Return:</p>
                      <RxDash />
                      <p>$ {plan.max_return} USD</p>
                    </div>

                    <div className="investrange-card invest-card">
                      <p>Minimum Return:</p>
                      <RxDash />
                        <p>$ {plan.min_return} USD</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>Referral Bonus:</p>
                      <RxDash />
                      <p> 10%</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>Duration:</p>
                      <RxDash />
                      <p>{plan.duration}</p>
                    </div>
                  </div>
                  <button
                    className="deposit-btn"
                    onClick={() => {
                      setActiveMethod({
                        id: `${plan.id}`,
                        min: `${plan.min}`,
                        max: `${plan.max}`,
                        image: `${plan.image}`,
                        method: `${plan.method}`,
                        type: `${plan.type}`,
                        percent: `${plan.apy}`,
                        plan: `${plan.type}`,
                        duration: `${plan.duration}`,
                        apy: `${plan.apy}`,
                        supportedAssets: plan.supportedAssets
                      });
                      setSelectedCrypto(plan.supportedAssets[0]);
                      setShowModal(true);
                    }}
                  >
                    Stake
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="swiper-container mobile-swiper-container">
            <Swiper
              // pagination={{
              //   type: "fraction",
              // }}
              navigation={true}
              spaceBetween={30}
              modules={[Pagination, Navigation]}
              className="mySwiper"
            >
              {withdrawMethods.map((withdrawmethod) => (
                <SwiperSlide key={withdrawmethod.id} className="my-slide">
                  <div className="crypto-card-img-container dashboard-plan-card-header">
                    <h3>{withdrawmethod.type}</h3>
                    <div className="plan-card-headerdiv">
                      <span className="small-plan-head">
                        <h3>{withdrawmethod.percent}</h3>
                        <p>everyday</p>
                      </span>
                      <span className="small-plan-head">
                        <h3>{withdrawmethod.duration}</h3>
                        <p>duration</p>
                      </span>
                    </div>
                  </div>
                  <div className="investrange-container investcard-cont">
                    <div className="investrange-card invest-card">
                      <p>minimum deposit</p>
                      <RxDash />
                      <p>$ {withdrawmethod.min} USD</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>maximum deposit</p>
                      <RxDash />
                      <p>$ {withdrawmethod.max} USD</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>capital return</p>
                      <RxDash />
                      <p>{withdrawmethod.percent}</p>
                    </div>
                    <div className="investrange-card invest-card">
                      <p>total return</p>
                      <RxDash />
                      <p> {withdrawmethod.percent}</p>
                    </div>
                  </div>
                  <button
                    className="deposit-btn"
                    onClick={() => {
                      setActiveMethod({
                        id: `${withdrawmethod.id}`,
                        min: `${withdrawmethod.min}`,
                        max: `${withdrawmethod.max}`,
                        image: `${withdrawmethod.image}`,
                        method: `${withdrawmethod.method}`,
                        type: `${withdrawmethod.type}`,
                        percent: `${withdrawmethod.percent}`,
                        plan: `${withdrawmethod.type}`,
                        duration: `${withdrawmethod.duration}`,
                      });
                      setSelectedCrypto(withdrawmethod.method);
                      setShowModal(true);
                    }}
                  >
                    choose plan
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <button
            className="history-btn"
            onClick={() => {
              navigate("/investments");
            }}
          >
            Stake history
            <FiArrowRight />
          </button>
        </div>
        ) : (
          <div className="staking-disabled-message">
            <h2>Staking is currently disabled</h2>
            <p>Please check back later or contact support for more information.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Userdashboardplans;
